<!-- eslint-disable vue/no-template-key -->
<!-- eslint-disable vue/valid-v-for -->
<template>
  <div id="sync-card" v-loading="fullscreenLoading">
    <div
      style="display: flex; justify-content: space-between; align-items: center"
      class="newDeploy"
    >
      <h3>{{ title }}</h3>
    </div>
    <div
      v-if="syncs.length > 0"
      class="grid grid-cols-1 md:gird-cols-2 xl:grid-cols-2 justify-item py-2 gap-2"
    >
      <template v-for="item in syncs">
        <el-card
          shadow="hover"
          class="h-full"
          style="min-height: 160px"
          :class="item.color"
        >
          <div
            class="flex space-y-4 justify-between w-full h-full"
            v-if="!item.setDate"
          >
            <div class="flex space-x-3 justify-between w-full items-center">
              <div class="flex flex-col space-y-2">
                <div class="text-lg">{{ item.text }}</div>
                <div class="flex space-x-4">
                  <div
                    class="text-xs text-justify"
                    v-html="item.description"
                  ></div>
                </div>
              </div>

              <div class="justify-end">
                <el-button
                  class="h-10"
                  :type="item.buttonAttr.type"
                  :icon="item.buttonAttr.icon"
                  :disabled="item.buttonAttr.disabled"
                  @click="doSync(item)"
                >
                  {{ item.buttonAttr.text }}
                </el-button>
              </div>
            </div>
          </div>

          <div
            class="flex flex-col space-y-4 justify-between w-full h-full"
            v-else
          >
            <div class="flex flex-col space-x-0 space-y-2">
              <div class="text-lg py-2">{{ item.text }}</div>
              <div class="text-xs text-justify" v-html="item.description"></div>
            </div>
            <div class="flex space-x-2">
              <el-date-picker
                v-model="item.dateRange"
                value-format="yyyy-MM-dd"
                type="daterange"
                start-placeholder="Start date"
                end-placeholder="End date"
                v-if="item.setDate"
              />
              <el-button
                class="h-10"
                :type="item.buttonAttr.type"
                :icon="item.buttonAttr.icon"
                :disabled="
                  item.buttonAttr.disabled ||
                  item.dateRange === null ||
                  item.dateRange.length === 0
                "
                @click="doSync(item)"
              >
                {{ item.buttonAttr.text }}
              </el-button>
            </div>
          </div>
        </el-card>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.fetchManualPullOptions()
  },
  data() {
    return {
      loading: false,
      title: 'Sync Data',
      fullscreenLoading: false,
      syncs: []
    }
  },
  methods: {
    async fetchManualPullOptions() {
      try {
        const res = await this.$axios.get(
          this.$appInfo.api.scheduler.getListManualPullOptions
        )
        this.syncs = res.data.map((data, index) => {
          return {
            id: index,
            text: data.Description,
            url: data.Url,
            color: data.Color,
            setDate: data.IsSetDate,
            buttonAttr: data.ButtonAttrObj,
            description: data.Comment,
            dateRange: ''
          }
        })
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async doSync(item) {
      // start sync process
      item.buttonAttr = {
        text: 'Please wait ...',
        icon: 'el-icon-loading',
        type: 'warning',
        disabled: true
      }

      this.$notify.info({
        title: `Sync ${item.text}`,
        message: `This may take a few moments.`,
        type: 'success'
      })

      var data = {}
      if (item.setDate) {
        data.params = {
          startDate: item.dateRange[0],
          endDate: item.dateRange[1]
        }
      }

      // fetching data
      await this.fetchData(item, data)
    },

    async fetchData(item, data = {}) {
      try {
        const res = await this.$axios
          .get(item.url, data)
          .then(() => {
            this.$notify({
              title: 'Sync Complete',
              message: `Data has been Synced successfully`,
              type: 'success',
              duration: 10000
            })

            // end sync process
            item.buttonAttr = {
              text: 'Sync Done',
              icon: 'el-icon-finished',
              type: 'success',
              disabled: false
            }
          })
          .catch((error) => {
            var response = error.response
            var message = 'System Error. Please contact the administrator'

            if (response.status !== 500) {
              message = response.data.message
            }

            // end sync process
            item.buttonAttr = {
              text: 're-sync Data',
              icon: 'el-icon-finished',
              type: 'success',
              disabled: false
            }

            this.$notify({
              title: 'Sync Failed',
              message: message,
              type: 'error',
              duration: 10000
            })
            throw message
          })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style>
#sync-card .el-card .el-card__body {
  height: 100%;
}
</style>
